export default {
    'fastcompany.com': 'fastcompany',
    'fastcodesign.com': 'codesign',
    'fastcocreate.com': 'cocreate',
    'fastcoexist.com': 'coexist'
};
